export default {
  total: {
    en: 'Total',
  },
}
